/* Fantasy Forged - "3 In Stock" / "4+ In Stock" on the PRODUCT PAGE only.

   Two jobs, both of which exist because the count is rendered by a Custom Liquid block. That block is
   the only insertion point available without rewriting sections/main-product.liquid, a 100 KB file,
   and it has two shortcomings this file fixes.

   1. PLACEMENT. The block renders after the quantity block, so the count lands under the +/- control
      instead of in the empty space beside the "Quantity" label. Moving it inside
      .product-form__quantity lets assets/ff-stock-left.css position it against that element honestly,
      with no measured offset.

   2. STALENESS, which matters more. assets/product-info.js does NOT re-render the page on a variant
      change. It refreshes a fixed list - #price, #Sku, #Inventory, #Volume, #Price-Per-Item - plus,
      inside the quantity form, .quantity__input attributes and the innerHTML of .quantity__rules and
      .quantity__label. A Custom Liquid block is outside all of that, so a shopper switching from Near
      Mint to Lightly Played would keep reading the Near Mint count.

      It does, however, publish variantChange carrying `html`: the freshly fetched copy of the whole
      section, which contains the Custom Liquid block rendered for the NEW variant. So the correct
      count is already in hand and this only has to copy it across. No second request, and no
      arithmetic here that could drift from the Liquid - snippets/ff-stock-left.liquid stays the one
      place that decides what the text says.

   Deliberately NOT moved into .quantity__label, which would look identical: product-info.js replaces
   that element's innerHTML, so the badge would be destroyed on the first variant change. A direct
   child of .product-form__quantity is untouched by every path above. */

(() => {
  if (window.ffStockLeftReady) return;
  window.ffStockLeftReady = true;

  const SELECTOR = '[data-ff-stock-left]';

  /* Returns the badge, having moved it inside the quantity block if it is still sitting outside.
     Idempotent: once moved, the first query finds it and nothing happens. */
  function placed() {
    const quantity = document.querySelector('.product-form__quantity');
    if (!quantity) return null;

    const inside = quantity.querySelector(SELECTOR);
    if (inside) return inside;

    /* General sibling, not adjacent: with_styles makes the snippet emit its <link> before the span,
       so the span is not necessarily the element immediately after the quantity block. */
    const outside = document.querySelector(`.product-form__quantity ~ ${SELECTOR}`);
    if (outside) quantity.appendChild(outside);
    return outside;
  }

  function sync(html) {
    const badge = placed();
    if (!badge) return;

    /* No fresh copy means the variant is unavailable or the section came back without the block.
       Clearing is the safe reading - better a missing count than the previous variant's. */
    const fresh = html && html.querySelector(SELECTOR);
    badge.textContent = fresh ? fresh.textContent : '';
    badge.hidden = fresh ? fresh.hasAttribute('hidden') : true;
    /* "Only 2 left" is gold (audit plan p-57), and it is per variant, so the colour has to follow the
       text: copied from the same fresh element, never worked out here. */
    badge.classList.toggle('ff-stock-left--low', !!fresh && fresh.classList.contains('ff-stock-left--low'));
  }

  placed();
  document.addEventListener('DOMContentLoaded', placed);

  /* pubsub.js defines these globally and is loaded in the head; this file is deferred, so they exist
     by now. Guarded anyway: a theme update that renames them should cost the live count, not throw
     on every product page. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => sync(event && event.data && event.data.html));
  }
})();
